import { define } from '../../define.js';
import { Spinner } from './spinner.js';
export * from './spinner.js';
define('spinner', Spinner);
